import type { RefPermissionEnum as Permission } from '@trinity/management-app-client';
import { RefRoleEnum as Role } from '@trinity/management-app-client';

type HasRole = (user: { roles: Role[] }) => boolean;

export const hasInternalAdminRole: HasRole = user => {
  return user.roles.some(r => r === Role.SystemAdmin);
};

export const hasAnalystRole: HasRole = user => {
  return user.roles.some(r => r === Role.FieldUser);
};

export const hasDataStewardRole: HasRole = user => {
  //return user.roles.some(r => r === Role.DataSteward);
  return false;
};

export const hasClientRole: HasRole = user => {
  return user.roles.some(r => r === Role.FieldUser);
};

export const hasComplianceRole: HasRole = user => {
  //return user.roles.some(r => roles.compliance.includes(r));
  return false;
};

export const hasConsultantRole: HasRole = user => {
  //return user.roles.some(r => roles.consultant.includes(r));
  return false;
};

export const hasTransientRole: HasRole = user => {
  //return user.roles.some(r => roles.transient.includes(r));
  return false;
};

export const hasRecruiterRole: HasRole = user => {
  //return user.roles.some(r => roles.recruiter.includes(r));
  return false;
};

export const hasInsightsChatOnlyRole: HasRole = user => {
  //return user.roles.some(r => roles.chatOnly.includes(r));
  return false;
};

export const hasPermission: HasPermission = (user, permission) => {
  return user.permissions.some(p => p === permission);
};

export const hasInsightsChatAccess: HasChatAccess = (user, group) => {
  /*return (
    hasClientRole({ roles: user.roles }) &&
    hasPermission({ permissions: user.permissions }, Permission.BrandInsightsFullpage) &&
    group.features.insightsChat
  ) || (
      hasInsightsChatOnlyRole({ roles: user.roles }) &&
      group.features.insightsChat
    );
    */
  return true;
};

export const hasChatAccess: HasChatAccess = (user, group) => {

  /*
  if (!group.features) return false;

  if (group.features.disableMessaging) return false;

  const hasBetaPermission = hasPermission(user, Permission.BetaMain);

  if (!hasBetaPermission) return false;
  */

  return true;
};

type HasPermission = (user: { permissions: Permission[] }, permission: Permission) => boolean;
type HasChatAccess = (user: { permissions: Permission[]; roles: Role[] }, group: { typeId: number }) => boolean;

export function isInternalUser(group: { typeId: number }) {
  //return group.typeId === GroupType.Internal;
  return false;
}

export const isPlatformUser = (user: { roles: Role[] }) => {
  const hasRoles = user?.roles?.length > 0;

  if (!hasRoles) return false;

  return !(hasConsultantRole(user) || hasInternalAdminRole(user));
};

export const isNonAdminClient = (user: { roles: Role[] }) => {
  const hasRoles = user?.roles?.length > 0;

  if (!hasRoles) return false;

  return hasClientRole(user) && !hasInternalAdminRole(user);
};

export const isAdmin = (user: { roles: Role[] }) => {
  const hasRoles = user?.roles?.length > 0;

  if (!hasRoles) return false;

  return hasInternalAdminRole(user);
};

export const isExpert = (user: { roles: Role[] }) => {
  const hasRoles = user?.roles?.length > 0;

  if (!hasRoles) return false;

  return hasConsultantRole(user);
};